const ToastDisplay = ({ status, content, details }) => {
	return (
		<div className={`snackbar flex-row-left rounded-8 ${status}`}>
			{status === "success" ? (
				<i className="snackbar-icon ri-check-line text-white" />
			) : (
				<i className="snackbar-icon ri-error-warning-line text-white" />
			)}
			<div>
				<span className="snackbar-content text-sm text-white">{content}</span>
				{details && (
					<span className="label-md text-white block italic">{details}</span>
				)}
			</div>
		</div>
	);
};

export default ToastDisplay;
